<template>
  <div class="membres" :class="{ marginBandeau: $store.state.bandeau }">
    <LigneTitre>
      <h2>Profils bloqués</h2>
    </LigneTitre>
    <ListeMembres ref="liste" :pattern="pattern" :save="false" :deleteButton="true" @onDelete="onDelete">
      <div>
        Vous n'avez bloqué aucun profil.
      </div>
    </ListeMembres>
  </div>
</template>

<script>
import ListeMembres from "@/components/membres/ListeMembres";
import BaseMembres from "@/components/membres/BaseMembres";
import LigneTitre from "@/components/membres/LigneTitre";

import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";

export default {
  name: "Blacklist",
  components: { ListeMembres, LigneTitre },
  extends: BaseMembres,
  data() {
    return {};
  },

  methods: {
    initPattern: function() {
      this.baseInitPattern();
      this.pattern.blacklist = true;
      this.alertName = "Profils bloqués";
    },

    onDelete: async function(result, index) {
      if (await confirm("Voulez-vous débloquer ce profil ?")) {
        await idyuJsonRpc("removeRelation", result.profile.id, 1);
        this.$refs.liste.resultsList.splice(index, 1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/base_membres.scss";
</style>
